import { menuRoute, successRoute, vivaRoute } from "@/App";
import Loader from "@/components/Loader";
import { useVivaTransaction } from "@/hooks/useVivaTransaction";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { Link } from "lucide-react";
import { useEffect } from "react";

export function VivaPage() {
  const { locationId } = vivaRoute.useParams();
  const navigate = useNavigate();
  const search = useSearch({
    strict: false,
  });

  const { data, isLoading: isPending } = useVivaTransaction(
    locationId,
    search.t
  );

  useEffect(() => {
    // If the status is COMPLETED, we can redirect to the success page
    if (data?.status === "COMPLETED" && data?.paymentId) {
      navigate({
        to: successRoute.to,
        replace: true,
        params: { locationId, paymentId: data?.paymentId },
      });
    }
  }, [data?.status]);

  return (
    <>
      <ThemeProvider />
      <main className="bg-background px-4 pb-24 pt-16 sm:px-6 sm:pt-24 lg:px-8 lg:py-32 relative">
        {isPending ||
          (data?.status == "PENDING" && (
            <div className="fixed bg-background z-1 inset-0 w-full h-screen flex items-center justify-center text-muted-foreground gap-4">
              <p>Loading...</p>
              <Loader />
            </div>
          ))}
        {data?.status == "FAILED" && (
          <div className="fixed bg-background z-1 inset-0 w-full h-screen flex items-center justify-center text-muted-foreground gap-4">
            <p>An error occured with your payment. You have not been charged</p>
            <Link to={menuRoute.to} className="text-primary">
              Return to menu
            </Link>
          </div>
        )}
      </main>
    </>
  );
}
